export default __webpack_public_path__ + "static/media/strong_311.c323cffd.jpeg";